import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { performCmdbDeleteRequest } from '@atlassian/jira-servicedesk-cmdb-client/src/fetch.tsx';
import { getCmdbRestBaseUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/index.tsx';
import type { ActionApi } from '../../common/types.tsx';

// TODO KKT-102 : verify if the task name is needed
export const CDM_DELETE_BUNDLE_TASK = 'deleteBundle';

export const deleteCdmInstantiatedBundle =
	(instantiationId: string): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		const state = getState();

		setState({
			...state,
			cdm: {
				...state.cdm,
				tasks: [...state.cdm.tasks, CDM_DELETE_BUNDLE_TASK],
			},
		});

		try {
			await performCmdbDeleteRequest(
				`${getCmdbRestBaseUrl(workspaceId)}/bundle/instantiated/${instantiationId}`,
			);

			const currentState = getState();
			setState({
				...currentState,
				cdm: {
					...currentState.cdm,
					tasks: currentState.cdm.tasks.filter((task) => task !== CDM_DELETE_BUNDLE_TASK),
				},
			});

			fireTrackAnalytics(createAnalyticsEvent({}), 'deleteCdmInstantiatedBundle succeeded');
		} catch (error) {
			const currentState = getState();
			setState({
				...currentState,
				cdm: {
					...currentState.cdm,
					tasks: currentState.cdm.tasks.filter((task) => task !== CDM_DELETE_BUNDLE_TASK),
				},
			});

			fireCmdbErrorAnalytics({
				meta: {
					id: 'deleteCdmInstantiatedBundle',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'aurum',
				},
				error:
					error instanceof Error
						? error
						: new Error('Unknown error on deleteCdmInstantiatedBundle'),
			});

			throw error;
		}
	};
